import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import '../firstaid.css';
import AdventureCard from '../../../components/AdventureCard';
import FIRSTAIDIMAGES from '../../../assets/designSystem/icons/firstAid';
import SIGNSANDSYMPTOMSIMAGES from '../../../assets/designSystem/icons/signsAndSymptoms';
import KitoMascot from '../../../components/Mascot';

export default function QuizMultipleChoice(props) {
  const {
    mascot,
    intro,
    question,
    answer,
    options,
    stepcolors,
    choices = [],
    setChoice,
    setAnsweredQuestion,
    symptoms,
  } = props;
  const { t } = useTranslation();

  const handleChoice = (choice) => {
    setAnsweredQuestion(t(answer));
    if (choice.correct) {
      setChoice(t(choices[0]));
    } else setChoice(t(choices[1]));
  };

  const STEPS = useMemo(() => {
    return options.map((option, index) => ({
      image: symptoms ? SIGNSANDSYMPTOMSIMAGES[option.icon] : FIRSTAIDIMAGES[option.icon],
      label: t(option.label),
      color: stepcolors[index],
      correct: option.correct,
    }));
  });

  return (
    <div>
      <KitoMascot image={mascot} textVariant="title">
        {t(intro)}
      </KitoMascot>
      <AdventureCard text={t(question)} quiz />
      <div className="procedure__container">
        {STEPS.map((step) => (
          <Card key={step.label} onClick={() => handleChoice(step)} {...step} />
        ))}
      </div>
    </div>
  );
}

function Card({ image, label, color, onClick }) {
  return (
    <button type="button" onClick={onClick} className="qstnCard__container" style={{ backgroundColor: color }}>
      <img alt={label} src={image} className="card__banner" />
      <p className="card__label">{label}</p>
    </button>
  );
}

QuizMultipleChoice.defaultProps = {
  choices: [],
  symptoms: false,
};

QuizMultipleChoice.propTypes = {
  intro: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      correct: PropTypes.bool.isRequired,
    })
  ).isRequired,
  stepcolors: PropTypes.arrayOf(PropTypes.string).isRequired,
  choices: PropTypes.arrayOf(PropTypes.string),
  setChoice: PropTypes.func.isRequired,
  setAnsweredQuestion: PropTypes.func.isRequired,
  symptoms: PropTypes.bool,
};
